module.exports = __webpack_public_path__ + "static/datamanEnM-1785cb6986ab3187a2cfb827b57e9dba.png";